/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { APPLICATION_VIEW_OFFICE } from '@gh/builder-shared-data';
import { createRoute } from '@gh/common-shared';
import { ContactsTabContainerComponent } from './components/contacts-tab-container/contacts-tab-container.component';
import { CustomFieldListTabComponent } from './components/custom-field-list-tab/custom-field-list-tab.component';
import { LocationListTabComponent } from './components/location-list-tab/location-list-tab.component';
import { CustomFieldListBusinessService } from './resources/custom-field-list-business.service';
import { LocationBusinessService } from './resources/location-business.service';

const routes = [
  createRoute({
    component: ContactsTabContainerComponent,
    path: '',
    auth: {
      applicationView: APPLICATION_VIEW_OFFICE,
    },
    children: [
      createRoute({
        component: LocationListTabComponent,
        init: LocationBusinessService,
        path: 'locations',
        auth: {
          applicationView: APPLICATION_VIEW_OFFICE,
          permission: [
            'Setup.Contacts.CityStateZipCodes.LIST',
          ],
        },
      }),
      createRoute({
        component: CustomFieldListTabComponent,
        path: 'custom-fields',
        init: CustomFieldListBusinessService,
        auth: {
          applicationView: APPLICATION_VIEW_OFFICE,
          permission: [
            'Setup.Contacts.CustomFields.LIST',
          ],
        },
      }),
    ],
  }),
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class BuilderSetupContactsRoutingModule {
}
